import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 承兑订单列表接口
export const getExchangeOrderList = (params: any) => request({
  url: '/manage/exchange-order',
  method: 'get',
  params
})

// 承兑订单统计接口
export const getExchangeStatistics = (params: any) => request({
  url: '/manage/exchange-order-statistics',
  method: 'get',
  params
})

// 承兑子订单接口
export const getExchangeSonInfo = (params: any) => request({
  url: `/manage/order/${params}/exchange-info`,
  method: 'get',
})

// 承兑订单详情接口
export const getExchangeDetail = (params: any) => request({
  url: `/manage/exchange-order/${params}`,
  method: 'get',
})
